import React, { lazy } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { loadRemote } from '@module-federation/enhanced/runtime';
import {
  isValidStaticMfePath,
  PLP_PATHS,
  checkSlug,
  isValidMembershipPath,
} from '../util/routeUtils';
import useCMSInjectedScript from './hooks/useCMSInjectedScript';

const ROUTES = {
  product: lazy(() => loadRemote('pdpMfe/PdpView')),
  cart: lazy(() => loadRemote('cartMfe/CartView')),
  myCoupons: lazy(() => loadRemote('couponsMfe/CouponsView')),
  category: lazy(() => loadRemote('plpMfe/MainLayout')),
  search: lazy(() => loadRemote('plpMfe/MainLayout')),
  staticRoute: lazy(() => loadRemote('staticMfe/StaticView')),
  membership: lazy(() => loadRemote('membershipMfe/RootComponent')),
};

function AppRouter({
  pageData: {
    staticData = {},
    membershipData = {},
    plpData = {},
    pdpData = {},
    importMaps = {},
  } = {},
  storeConf = {},
  sharedConfig = {},
}: any) {
  useCMSInjectedScript();
  const location = useLocation();
  const [searchParams, _] = useSearchParams();
  const currentRoute = location.pathname?.split('/')[1] || '';
  const isShopAll = searchParams.get('shopall')?.toLowerCase() === 'y';

  const getMfeRoute = () => {
    // Handling shopall=y
    if (checkSlug(PLP_PATHS, currentRoute, isShopAll)) {
      return ROUTES.search; // PLP mfe - reusing the key search
    }

    if (isValidMembershipPath(currentRoute.toLowerCase())) {
      return ROUTES.membership;
    }

    // Handling other routes
    if (Object.keys(ROUTES).includes(currentRoute)) {
      return ROUTES[currentRoute];
    }

    if (isValidStaticMfePath(currentRoute, isShopAll)) {
      return ROUTES.staticRoute;
    }
    return null;
  };

  const Page = getMfeRoute();

  return (
    <>
      {Page && (
        <Page
          staticData={staticData}
          membershipData={membershipData}
          plpData={plpData}
          pdpData={pdpData}
          importMaps={importMaps}
          storeConf={storeConf}
          sharedConfig={sharedConfig}
        />
      )}
      {!Page && <p>Oops! Something went wrong.</p>}
    </>
  );
}

export default AppRouter;
